import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Tooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'
import ActionsMenu from 'components/actions-menu'
import SocialShareDialog from 'components/social-share-dialog'
import LinkOutlinedIcon from 'components/material-symbol/icons/Link'
import SettingsOutlinedIcon from 'components/material-symbol/icons/Settings'
import PersonAddOutlinedIcon from 'components/material-symbol/icons/PersonAdd'
import AddIcon from 'components/material-symbol/icons/Add'
import MoreHorizIcon from 'components/material-symbol/icons/MoreHoriz'
import bookingTypeStyles from '../booking-types/styles'

const useStyles = makeStyles(theme => ({
  menuItemIcon: {
    color: theme.palette.text.primary,
    minWidth: theme.spacing(5),
  },
  overflowButton: {
    minWidth: 40,
    width: 40,
    height: 40,
    padding: 0,
    borderRadius: '50px',
    border: '1px solid #E0E0E0',
    backgroundColor: '#FFFFFF',
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#F5F5F5',
      borderColor: '#E0E0E0',
      boxShadow: 'none',
    },
  },
}))

const OfferingsHeaderActions = ({
  user,
  isOnboardingComplete,
  isBookingTypeTab,
  shouldShowBookingTypeDisclaimer,
  onCreateBookingType,
  onCreateEvent,
  onBookStudentClick,
}) => {
  const classes = useStyles()
  const bookingTypeClasses = bookingTypeStyles()

  const primaryAction = isBookingTypeTab ? (
    <Tooltip
      title={
        shouldShowBookingTypeDisclaimer
          ? 'To add another offering, you need to upgrade your PGA Coach account.'
          : ''
      }
    >
      <Button
        variant="contained"
        color="primary"
        data-cy="createBookingType"
        onClick={onCreateBookingType}
        startIcon={<AddIcon />}
        className={
          shouldShowBookingTypeDisclaimer
            ? bookingTypeClasses.disabledButton
            : undefined
        }
      >
        Create Booking Type
      </Button>
    </Tooltip>
  ) : (
    <Button
      variant="contained"
      color="primary"
      onClick={onCreateEvent}
      startIcon={<AddIcon />}
    >
      Create Event
    </Button>
  )

  return (
    <>
      {primaryAction}
      <ActionsMenu
        ariaId="offerings"
        buttonContent={<MoreHorizIcon />}
        className={classes.overflowButton}
        color="default"
        variant="outlined"
      >
        <SocialShareDialog
          trigger={
            <MenuItem>
              <ListItemIcon className={classes.menuItemIcon}>
                <LinkOutlinedIcon fontSize="small" />
              </ListItemIcon>
              Share Booking Link
            </MenuItem>
          }
          shareUrl={user.coach.bookingUrl}
          shareTitle="My Offerings"
          showBookingUrl
          att="booking-link"
        />
        <MenuItem component={RouterLink} to="/pga-coach/settings/availability">
          <ListItemIcon className={classes.menuItemIcon}>
            <SettingsOutlinedIcon fontSize="small" />
          </ListItemIcon>
          Availability Settings
        </MenuItem>
        {isOnboardingComplete ? (
          <MenuItem
            component="a"
            href={user.coach.bookingUrl}
            target="_self"
            onClick={onBookStudentClick}
            data-testid="book-student"
          >
            <ListItemIcon className={classes.menuItemIcon}>
              <PersonAddOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Book a Student
          </MenuItem>
        ) : null}
      </ActionsMenu>
    </>
  )
}

export default OfferingsHeaderActions
